<template>
  <!-- questo markup contiene le parti generiche. E' qui solo per essere copiato nella destinazione, viene sovrascritto da quello presente nella destinazione -->
  <div class="mt-2">
    <!-- <div :style="[!noInnerWidth ? { width: width } : {}]"> -->
    <div :style="{ width: !noInnerWidth ? width : 'auto' }">
      <div>
        <!-- Main table element -->
        <b-table
          :busy="isLoading"
          head-variant="light"
          :no-local-sorting="true"
          :items="items"
          :fields="getAllFields"
          :current-page="currentPage"
          per-page="0"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :sticky-header="height"
          no-border-collapse
          responsive
          show-empty
          empty-text="Non ci sono informazioni da mostrare"
          small
          @sort-changed="sortingChanged"
        >
          <template #table-busy>
            <table-skeleton />
          </template>
          <template #empty>
            <template v-if="newBookEntryDepositedBtn">
              <div
                class="d-flex flex-column justify-content-center align-items-center my-3"
                style="max-width: max-content; margin-inline: auto"
              >
                <p class="mb-2">
                  Effettua una ricerca oppure, se non trovi risultati, crea un
                  nuovo Acconto cliccando sul pulsante qui sotto
                </p>
                <b-button
                  class="btn-create"
                  type="button"
                  variant="primary"
                  size="sm"
                  @click="onAddNewBookEntryDeposited"
                  title="Crea"
                  :disabled="!canVerb(resource, 'store')"
                  style="max-width: max-content"
                >
                  <b-icon icon="plus-circle" aria-hidden="true"></b-icon>
                  Crea
                </b-button
                >
              </div>
            </template>
            <template v-else>
              <empty-table
                :isTableInModal="isTableInModal"
                :performedSearch="performedSearch"
                :automaticPerformedSearch="automaticPerformedSearch"
                :filterCount="filterCount"
              />
            </template>
          </template>
          <template #cell(remainder)="{ item }" v-if="items">
            {{ toLocaleCurrency(getRemainder(item)) }}
          </template>
          <template #cell(actions)="row">
            <div class="action-buttons">
              <b-button
                v-if="actions.includes('infomodal')"
                size="sm"
                variant="lisaweb"
                @click="openModal(row.item, row.index, $event.target)"
                class="mt-1 mr-1"
                title="Modale Dettagli"
              >
                <base-icon name="eye"></base-icon>
              </b-button>
              <b-button
                v-if="actions.includes('edit')"
                size="sm"
                variant="lisaweb"
                @click="onEdit(row.item.id, row.item)"
                class="mt-1 mr-1"
                :disabled="hasBeenDeposited(row.item)"
                title="Modifica"
              >
                <base-icon name="edit"></base-icon>
              </b-button>
              <b-button
                v-if="actions.includes('destroy')"
                size="sm"
                variant="lisaweb"
                @click="onDestroy(row.item.id, row.item)"
                class="mt-1 mr-1"
                :disabled="hasBeenDeposited(row.item)"
                title="Elimina"
              >
                <base-icon name="trash"></base-icon>
              </b-button>
            </div>
          </template>
          <template #cell(recovery_status)="{ item }">
            <status-badge kind="recovery" :status="recoveryStatus(item)" />
          </template>
          <template #cell()="{ value }">
            <span>{{ value }}</span>
          </template>
        </b-table>
      </div>
      <pagination-skeleton v-if="isLoading && !noPagination" />
      <div
        class="pagination-wrapper"
        v-if="!isLoading && !noPagination && items.length"
      >
        <div class="info">
          <div class="show-text">
            <p>
              <label for="per-page-select-correspondences"
              >Numero di risultati per pagina:</label
              >
            </p>
          </div>
          <div class="group">
            <b-form-group label-for="per-page-select">
              <b-form-select
                id="per-page-select-correspondences"
                v-model="perPage"
                :options="pageOptions"
                style="width: 68px"
                size="sm"
                @change="onPageChange(1)"
                :disabled="!items.length"
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="page">
            <p>
              Risultati da
              <strong>{{ formatItemsFrom }}</strong> a
              <strong>{{ formatItemsTo }}</strong> su un totale di
              <strong>{{ formatTotalItems }}</strong>
            </p>
          </div>
        </div>
        <div class="info-action">
          <div class="pagination" v-if="totalItems">
            <b-pagination
              v-model="currentPage"
              limit="3"
              :total-rows="totalItems"
              :per-page="perPage"
              size="sm"
              @change="onPageChange"
            >
              <template #page="{ page, active }">
                <span :data-active="active">{{
                    page.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                  }}</span>
              </template>
              <template v-slot:first-text>
                <span
                ><base-icon
                  scale="-1"
                  name="chevron_right_last_rounded"
                  width="16"
                  height="16"
                /></span>
              </template>
              <template v-slot:prev-text>
                <span
                ><base-icon
                  scale="-1"
                  name="chevron_right_rounded"
                  width="16"
                  height="16"
                /></span>
              </template>
              <template v-slot:next-text>
                <span
                ><base-icon
                  name="chevron_right_rounded"
                  width="16"
                  height="16"
                /></span>
              </template>
              <template v-slot:last-text>
                <span
                ><base-icon
                  name="chevron_right_last_rounded"
                  width="16"
                  height="16"
                /></span>
              </template>
            </b-pagination>
          </div>
          <div
            class="input_pagination"
            v-if="
              totalItems && !noInputPaginator && totalPages && totalPages > 3
            "
          >
            <base-input-pagination
              @pagination="onInputPagination"
            ></base-input-pagination>
          </div>
        </div>
      </div>
      <b-modal
        :id="infomodalName"
        @hidden="onModalHidden"
        :title="modalTitle"
        size="xl"
        scrollable
        ok-only
        ok-variant="lisaweb"
        header-bg-variant="lisaweb"
        no-close-on-backdrop
      >
        <div>
          <b-tabs content-class="pt-1" lazy v-model="tabIndex">
            <b-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="setTab(tab, index)"
              :title="tab.text"
              :active="index === tabIndex"
              title-item-class="lisaweb"
            >
              <button-group-tab></button-group-tab>

              <keep-alive>
                <component
                  v-if="selected === tab.name"
                  :is="selected"
                  :resourceId="modalResourceId"
                  :dbRowData="dbRowData"
                  @fetch="fetch"
                ></component>
              </keep-alive>
            </b-tab>
          </b-tabs>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import template from "./template";
import StatusBadge from "@/components/StatusBadge";
import BaseIcon from "@/components/BaseIcon";
import ButtonGroupTab from "@/components/ButtonGroupTab";
import EmptyTable from "@/components/EmptyTable.vue";
// import General from "@/components/accounting/book-entries/details/General.vue";
import General from "@/components/accounting/cash-entries/deposit/details/General";
import Deposited from "@/components/accounting/cash-entries/deposit/details/Deposited";
import {toLocaleCurrency} from "@/utils/strings";
import {toLocaleDate} from "@/utils/dates";

export default {
  name: "DepositedEntryDetailsTable",
  extends: template,
  props: {
    depositedStatus: {
      type: String,
      default: "",
    },
    performedSearch: {
      type: Boolean,
      default: false,
    },
    filterCount: {
      type: Number,
      default() {
        return 0;
      },
    },
    isTableInModal: {
      type: Boolean,
      default: false,
    },
    newBookEntryDepositedBtn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tabs: [
        {name: "General", text: "Generale"},
        {name: "Deposited", text: "Storico Acconti"},
      ],
      selected: "General",
      modalResourceId: null,
      tabIndex: 0,
      dbRowData: null,
      args: {verb: {name: "acconti", alias: "index"}},
    };
  },
  methods: {
    toLocaleCurrency,
    toLocaleDate,
    // Stato di recupero: chiuso se il recupero copre l'importo, parziale se
    // c'è già un recupero, altrimenti aperto (toni in utils/statusBadge.js).
    recoveryStatus(item) {
      let value = 0;
      if (item?.recupero) value = item.importo === item.recupero ? 2 : 1;
      return {
        value,
        text: ["Aperto", "Parziale", "Chiuso"][value],
        title: value === 1 ? "Parzialmente recuperato" : null,
      };
    },
    onAddNewBookEntryDeposited() {
      this.$router.push({
        name: `${this.resource}.create`,
        params: {
          /* remove the / character if it is the first character of a string */
          returnUrl: this.$route.path.replace(/^\/(.*)/, "$1"),
        },
      });
    },
    freeSearch() {
      this.$emit("manualFetch");
    },
    hasBeenDeposited(item) {
      if (item?.recupero) return true;
      return false;
    },
    totalDeposited(item) {
      if (!item?.reduced) {
        return false;
      }
      return this.getRemainder(item) === 0;
    },
    partialDeposited(item) {
      if (!item?.reduced) {
        return false;
      }
      return Math.abs(item?.reduced) < item?.gross;
    },
    getRemainder(item) {
      return item?.gross + item?.reduced;
    },
    getDepositedId(item) {
      return item.treasury.code === "SS" && parseFloat(item.gross) < 0
        ? item.id
        : null;
    },
    isLastRow(index) {
      return index === this.items.length - 1;
    },
    hasAbbuoni() {
      let allIds = [];
      let items = this.$parent.$parent.details || [];
      for (const i of items) {
        let id = this.getDepositedId(i);
        if (id) allIds.push(id);
      }
      for (const id of allIds) {
        const found = items.find((e) => e.id === id);
        if (found && found.entry_details) {
          const found2 = found.entry_details.find(
            (e) => e.treasury.code === "AB"
          );
          if (found2) {
            return true;
          }
        }
      }
      return false;
    },
    isAbbuono(item) {
      return item.treasury.code === "AB";
    },
    isRecuperoAcconto(item) {
      // #1008: modifica temporanea in questa table
      return item.treasury.code === "UC";
    },
  },
  // beforeMount() {
  //   this.args = this.$parent.$parent.args;
  // },
  components: {
    StatusBadge,
    BaseIcon,
    General,
    Deposited,
    ButtonGroupTab,
    EmptyTable,
  },
  computed: {
    formatItemsFrom() {
      if (!this.totalItems) return "";
      return this.items_from.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatItemsTo() {
      if (!this.totalItems) return "";
      return this.items_to.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatTotalItems() {
      if (!this.totalItems) return "";
      return this.totalItems.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
};
</script>

<style lang="scss" scoped>
/*
:deep(.check) {
  width: 1px;
  // padding-left: 10px;
}
:deep(.check .form-group) {
  margin-bottom: unset !important;
}
*/
</style>
